import { Button } from 'reactstrap';
import TreeTitleActions, { TreeTitleActionType } from './TreeTitleActions';

import arrow from 'assets/svg/common/arrow.svg';

import ColorViewer from 'common/components/general/ColorViewer';
import TitleWithIcon from './TitleWithIcon';
import { FC, ReactNode } from 'react';

type TreeLayoutTitleProps = {
  hasChildren: boolean;
  onClick?: () => void;
  title: ReactNode;
  isActive: boolean;
  isHighlighted?: boolean;
  preffix?: string;
  onExpand?: () => void;
  parent_id?: number | null;
  post_count?: number;
  draft_change_request_count?: number;
  isOpen?: boolean;
  actions?: TreeTitleActionType[];
  disabledActions?: boolean;
  rightComponent?: React.ReactNode;
  leftComponent?: React.ReactNode;
  startComponent?: React.ReactNode;
  customIcon?: string;
  withRibbon?: boolean;
  withFolder?: boolean;
  hideIcon?: boolean;
  customIconComponent?: React.ReactNode;
  type?: string | null;
  color?: string;
};

const TreeLayoutTitle: FC<TreeLayoutTitleProps> = ({
  hasChildren,
  onClick,
  title,
  isActive,
  isHighlighted,
  preffix,
  onExpand,
  parent_id,
  post_count,
  draft_change_request_count,
  isOpen,
  actions,
  disabledActions = false,
  rightComponent,
  leftComponent,
  startComponent,
  customIcon,
  withRibbon = false,
  withFolder = false,
  hideIcon = false,
  customIconComponent = null,
  type,
  color
}) => {
  return (
    <div
      className={`chapters-tree__view-title d-flex flex-1 align-items-center${
        isActive ? ' active' : ''
      }`}
    >
      {hasChildren ? (
        <Button
          color="link"
          className="d-inline-flex align-items-center btn-subs-toggle"
          onClick={onExpand}
        >
          <img
            className={`base-transition`}
            alt="arrow"
            src={arrow}
            width={10}
            height={10}
            style={{
              transform: !isOpen ? 'rotate(-90deg)' : ''
            }}
          />
        </Button>
      ) : null}

      {startComponent ?? null}

      <TitleWithIcon
        hideIcon={hideIcon}
        onClick={onClick}
        customIconComponent={customIconComponent}
        parent_id={parent_id}
        type={type}
        post_count={post_count}
        preffix={preffix}
        title={title}
        draft_change_request_count={draft_change_request_count}
        customIcon={customIcon}
        withRibbon={withRibbon}
        withFolder={withFolder}
        isHighlighted={isHighlighted}
      />

      {color ? <ColorViewer color={`#${color}`} className={'ms-auto me-1'} hideLabel /> : null}

      {leftComponent ? leftComponent : null}

      {disabledActions ? null : (
        <TreeTitleActions actions={actions} disabled={actions ? false : true} />
      )}

      {rightComponent ? rightComponent : null}
    </div>
  );
};

export default TreeLayoutTitle;
